export default{
  problemaRaiz: null,
  morador: null,
  descricao: null,
  nomemorador: null,
  celular: null,
  telefone: null,
  cpf: null,
  empreendimentoid: null,
  empreendimentounidadeid: null,
  garantiaVistoria: false,
  manutencaogarantia: false,
  tecnicoid: null,
  tecniconome: null,
  engenheiroid: null,
  engenheironome: null,
  dataSolicitacao: null,
  horario: null,
  verificadatatechhora: false,
  email: null,
  patologia: null,
  apenasOrcamento: false,
  cortesia: false,
  garantia: false
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/technicalvisit/agendatechnical/data.js